import { Navigate, redirect, useLocation, useParams } from 'react-router-dom';

// The profile URL for an old link: query params carried over, the edit link
// opens edit mode.
const profileUrl = ({ basePath, id, search, mode }) => {
  const query = new URLSearchParams(search);
  if (mode === 'edit' && !query.has('mode')) query.set('mode', 'edit');
  const qs = query.toString();
  return `${basePath}/${id}${qs ? `?${qs}` : ''}`;
};

/**
 * Old /view/:id and /edit/:id links (bookmarks, emails, list actions, other
 * pages) open the profile.
 *
 * @param {Object} props
 * @param {string} props.basePath - e.g. /admin/employees
 * @param {string} props.param - route param holding the id
 * @param {'view'|'edit'} props.mode
 */
export default function ProfileRedirect({ basePath, param, mode }) {
  const params = useParams();
  const { search, state } = useLocation();

  return (
    <Navigate
      replace
      state={state}
      to={profileUrl({ basePath, id: params[param], search, mode })}
    />
  );
}

/**
 * Route props for an old link: the loader redirects before anything renders,
 * so the page that was open stays on screen until the profile is ready. (The
 * element alone rendered an empty page — no layout, only the background —
 * for as long as the profile took to render.)
 */
export const profileRedirectRoute = ({ basePath, param, mode }) => ({
  loader: ({ params, request }) =>
    redirect(
      profileUrl({
        basePath,
        id: params[param],
        search: new URL(request.url).search,
        mode,
      })
    ),
  element: <ProfileRedirect basePath={basePath} param={param} mode={mode} />,
});
